var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { cols: "4" } }, [
                        _vm._v("Select Template:")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "8 text-left" } },
                        [
                          _c("b-form-select", {
                            attrs: {
                              plain: true,
                              options: _vm.availableTemplateDocs
                            },
                            on: { change: _vm.handleSelectedTemplate },
                            model: {
                              value: _vm.selectedTemplateDocId,
                              callback: function($$v) {
                                _vm.selectedTemplateDocId = $$v
                              },
                              expression: "selectedTemplateDocId"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { cols: "4" } }, [
                        _vm._v("Select Page:")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "8 text-left" } },
                        [
                          _c("b-form-select", {
                            attrs: {
                              plain: true,
                              options: _vm.availableTemplates
                            },
                            on: { change: _vm.fetchTemplateVersion },
                            model: {
                              value: _vm.selectedTemplateId,
                              callback: function($$v) {
                                _vm.selectedTemplateId = $$v
                              },
                              expression: "selectedTemplateId"
                            }
                          }),
                          _vm._v(" "),
                          _vm.selectedTemplateId == null
                            ? _c("div", { staticStyle: { color: "red" } }, [
                                _vm._v("Please select Page.")
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { cols: "4" } }, [
                        _vm._v("Select Version:")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "6 text-left" } },
                        [
                          _c("b-form-select", {
                            attrs: {
                              plain: true,
                              options: _vm.availableTemplateVersions
                            },
                            model: {
                              value: _vm.selectedTemplateVersion,
                              callback: function($$v) {
                                _vm.selectedTemplateVersion = $$v
                              },
                              expression: "selectedTemplateVersion"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-btn",
                        {
                          attrs: {
                            size: "sm",
                            variant: "secondary",
                            disabled: !(
                              _vm.selectedTemplateDocId &&
                              _vm.selectedTemplateId &&
                              _vm.selectedTemplateVersion
                            )
                          },
                          on: { click: _vm.fetchAutoCorrectData }
                        },
                        [_vm._v(" Fetch ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-row")
        ],
        1
      ),
      _vm._v(" "),
      _c("b-card", [
        _c("h4", [
          _vm._v("Auto Correct Fields:\n        "),
          _c(
            "div",
            { staticClass: "float-right add-field-btn" },
            [
              _c(
                "b-button",
                {
                  staticClass: "mt-0",
                  attrs: {
                    type: "submit",
                    size: "md",
                    variant: "secondary",
                    disabled: !(
                      _vm.selectedTemplateDocId &&
                      _vm.selectedTemplateId &&
                      _vm.selectedTemplateVersion
                    )
                  },
                  on: {
                    click: function($event) {
                      _vm.displayClearWarning()
                    }
                  }
                },
                [_vm._v(" Clear History ")]
              )
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _vm.wordMappings.length > 0
        ? _c(
            "b-row",
            _vm._l(_vm.wordMappings, function(word) {
              return _c(
                "b-col",
                { key: word.id, attrs: { sm: "3" } },
                [
                  _c("b-card", { attrs: { "border-variant": "secondary" } }, [
                    _c("h6", [
                      _vm._v(_vm._s(word.key) + "\n      "),
                      _c(
                        "div",
                        { staticClass: "float-right add-field-btn" },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mt-0",
                              attrs: {
                                type: "submit",
                                size: "sm",
                                variant: "danger"
                              },
                              on: {
                                click: function($event) {
                                  _vm.displayWarning(word)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-trash" })]
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ],
                1
              )
            })
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.wordMappings.length < 1 && _vm.loaded
        ? _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { sm: "12" } },
                [_c("center", [_c("h5", [_vm._v("No Data Found")])])],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "deleteModal",
          attrs: {
            centered: "",
            id: "deleteModal",
            title: _vm.$t("COMMON.DELETE_CONFIRM"),
            "no-close-on-esc": "",
            "no-close-on-backdrop": "",
            "hide-header-close": "",
            "ok-title": _vm.$t("COMMON.DELETE"),
            "cancel-title": _vm.$t("COMMON.CANCEL"),
            "ok-variant": "secondary",
            "cancel-variant": "light"
          },
          on: { cancel: _vm.cancel, ok: _vm.deleteAccountToken },
          nativeOn: {
            keydown: function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "enter", 13, $event.key)
              ) {
                return null
              }
              _vm.deleteAccountToken($event)
            }
          }
        },
        [
          _c("div", { staticClass: "delete-warning" }, [
            _c("p", [_vm._v(_vm._s(_vm.$t("COMMON.DEL_AUTO_CORRECT")))])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "deleteAllModal",
          attrs: {
            centered: "",
            id: "deleteAllModal",
            title: _vm.$t("COMMON.DELETE_CONFIRM"),
            "no-close-on-esc": "",
            "no-close-on-backdrop": "",
            "hide-header-close": "",
            "ok-title": _vm.$t("COMMON.CLEAR"),
            "cancel-title": _vm.$t("COMMON.CANCEL"),
            "ok-variant": "secondary",
            "cancel-variant": "light"
          },
          on: {
            cancel: _vm.cancelClearWarning,
            ok: _vm.deleteFromWordDataSetDictinory
          },
          nativeOn: {
            keydown: function($event) {
              if (
                !("button" in $event) &&
                _vm._k($event.keyCode, "enter", 13, $event.key)
              ) {
                return null
              }
              _vm.deleteFromWordDataSetDictinory($event)
            }
          }
        },
        [
          _c("div", { staticClass: "delete-warning" }, [
            _c("p", [_vm._v(_vm._s(_vm.$t("COMMON.DEL_AUTO_CORRECT_HISTORY")))])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b737742", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b737742","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/autoCorrect.vue
// module id = 1359
// module chunks = 2